<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">

        <h1 class="font-weight-bold text-primary mb-8 mt-4">التوعية</h1>
        <div class="h5 line-height-xl text-dark-65">
          <div class="mb-3">
            إنفاذاً للأمر السامي الكريم رقم (5604) وتاريخ 1439/2/5هـ القاضي في البند (خامساً) بشأن قيام كل جهة حكومية
            بالتنسيق مع المركز ، لإعداد وتنفيذ البرامج لتوعية منسوبيها بترشيد استهلاك الكهرباء فقد عمل المركز على تمكين
            الجهات الحكومية من خلال :
          </div>
          <ul>
            <li class="my-1">وضع خطة سنوية للبرامج التوعوية وتزويد الجهات بها.</li>
            <li class="my-1">عقد ورش عمل تعريفية مع ممثلي الجهات للشان التوعوي.</li>
            <li class="my-1">إنتاج وإرسال مواد توعوية على مدار العام لممثلي الجهات.</li>
            <li class="my-1">عقد المحاضرات التوعوية لمنسوبي الجهات الحكومية بالتنسيق مع الممثلين.</li>
            <li class="my-1">التنسيق المستمر مع ممثلي الجهات الحكومية والرد على الاستفسارات بشأن البرامج التوعوية.</li>
            <li class="my-1">إعداد التقارير الدورية والنصف سنوية.</li>
          </ul>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>